import {
  AGENCY_UPSERT_SUCCESS,
  AGENCY_GETALL_SUCCESS,
  AGENCY_DELETE_SUCCESS
} from "../actions/types";

const initialState = { agencies: null }

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {

    case AGENCY_UPSERT_SUCCESS:
      if (state.agencies.filter(e => e.id == payload.id).length > 0) {
        return { ...state, agencies: state.agencies.map(agency => { return agency.id === payload.id ? payload : agency }) };
      } else {
        return { ...state, agencies: [...state.agencies, payload] }
      }
    case AGENCY_DELETE_SUCCESS:
      return { ...state, agencies: state.agencies.filter(agency => agency.id !== payload) }

    case AGENCY_GETALL_SUCCESS:
      return { ...state, agencies: payload.agencies };
    default:
      return { ...state };
  }
}